import * as t from 'io-ts';

import type { SelectDefinition } from 'header/types';

import { define, createSpecSettingsInterface } from './_common';

export interface SortSettingDefinition extends SelectDefinition {
    key: 'SORT';
}

const definition: SortSettingDefinition = {
    type: 'Select',
    key: 'SORT',
    label: 'Sort',
    options: [
        { key: 'none', label: 'No sort' },
        { key: 'label_asc', label: 'By text A-Z' },
        { key: 'key_asc', label: 'By key A-Z' },
        { key: 'label_desc', label: 'By text Z-A' },
        { key: 'key_desc', label: 'By key Z-A' },
    ],
    value: 'none',
};

const specSettingsInterface = createSpecSettingsInterface(definition, t.string);

export const codec = specSettingsInterface.input;

export const SortSettingDefinition = define({
    key: 'SORT',
    label: 'sort',
    definition,
    fromSetting: settings => specSettingsInterface.extractValue(settings.sort),
    createDefinitionWithOpts: (opts = {}) => ({ ...definition, ...opts }),
    createDefinitionFromSpec: settings =>
        specSettingsInterface.createDefinitionWithSettings(settings.sort),
});
